import React from 'react';
import { PostHogProvider } from '../app/providers/PostHogProvider';
import { usePostHogTracking } from '../hooks/usePostHogTracking';
import { useRouterPageTracking } from '../hooks/useRouterPageTracking';
import {
  useMemoryPerformanceTracking,
  useBundlePerformanceTracking,
} from '../hooks/usePostHogPerformance';
import { MainLayout } from './MainLayout';

/**
 * MainLayout wrapper component that adds PostHog tracking without changing styling
 */
const MainLayoutContent: React.FC = () => {
  // Initialize PostHog tracking with user context
  usePostHogTracking();

  // Track page views on route changes
  useRouterPageTracking();

  // Track performance metrics
  useMemoryPerformanceTracking();
  useBundlePerformanceTracking();

  // Return the original MainLayout unchanged
  return <MainLayout />;
};

/**
 * MainLayout wrapper that provides PostHog tracking context
 */
export const MainLayoutWithTracking: React.FC = () => {
  return (
    <PostHogProvider>
      <MainLayoutContent />
    </PostHogProvider>
  );
};
